<template>
  <div class="min-h-screen flex flex-col">
    <header
      :class="[
        'bg-white border-b border-gray-200 transition-[top,opacity] duration-200 ease-in-out top-0',
        computedPositionClass,
      ]"
    >
      <nav class="hidden lg:flex h-20 mx-auto items-center justify-between gap-x-4 px-4">
        <AppHeaderLogo
          :to="localePath({ name: 'index' })"
          class="self-center"
        />

        <template v-if="isHeaderSearchFormInHeader">
          <AtomTransition
            v-if="hydrationStatus"
            timing="fast"
            :is-disabled="!isRenderedHeaderSearchFormVisibilityDynamic"
          >
            <LazySearchFormBar
              v-show="isHeaderSearchFormVisible"
              is-toggleable
              has-rental-type
              class="grow mx-auto justify-items-center"
            />
          </AtomTransition>
        </template>

        <div class="flex items-center gap-x-4">
          <div class="hidden md:block">
            <NuxtLink
              :to="localePath({ name: 'owner' })"
              class="text-sm/6 font-semibold text-primary-950 rounded-full py-2.5 px-4 whitespace-nowrap transition-colors duration-300 ease-in-out hover:bg-gray-50"
            >
              {{ t('pageLink.listAnRV') }}
            </NuxtLink>
          </div>
        </div>
      </nav>

      <div
        v-if="isHeaderSearchFormInHeader"
        class="flex lg:hidden items-center gap-x-2 p-2 transition-all duration-300 ease-in-out bg-white"
      >
        <SearchFormMobileTrigger
          has-rental-type
          class="flex-1 min-w-0"
        />
      </div>
    </header>

    <slot />

    <AppFooter
      :variant="route.meta?.footerVariant"
      class="mt-auto"
    />
  </div>
</template>

<script setup lang="ts">
/**
 * This layout is mainly used for POI pages that are cached on the server
 */
const { t } = useI18n()
const route = useRoute()
const localePath = useLocalePath()

const hydrationStatus = useHydrationStatus()
const { isHeaderSearchFormInHeader, isHeaderSearchFormVisible, isRenderedHeaderSearchFormVisibilityDynamic } = useHeaderSearchFormVisibility()

const computedPositionClass = computed(() => {
  if (route.meta?.staticHeader) {
    return 'static'
  }

  return 'sticky z-30'
})

await useScripts()
</script>

<i18n src="~~/i18n/locales/common/app.json" lang="json" />
